// Sponsor tier catalog — source of truth for /sponsor page + form.
// Update copy here to change what's shown to users.
export const SPONSOR_TIERS = [
  {
    slug: "title-partner",
    label: "Title Partner",
    price: "$4,500",
    spotsLabel: "1 spot · category-exclusive",
    tagline: "The biggest brand moment of the weekend — and the biggest reach after it. Personal endorsement from Jacob Siegel, dedicated content across a 4M+ subscriber network, and full seat at every table.",
    perks: [
      // Personal endorsement
      "🎬 Personal on-camera endorsement from Jacob Siegel, founder of Superhero Swim University",
      "📢 Distributed across the SSU network — 4M+ combined subscribers across YouTube, Instagram, TikTok & Facebook",
      // Content deliverables
      "🎥 Dedicated branded video produced by our team, featuring your product/service in action at the event",
      "🎞️ Full raw footage of the entire event delivered post-workshop — yours to cut and use forever",
      "✨ Custom-branded highlight reel with your logo/product woven throughout, ready for your channels",
      "🎙️ Attendee testimonials on-camera about your product — real swim-school owners, real reactions",
      // On-stage / on-property
      "⏱️ 30-minute presentation on the main stage — not a shoutout, a real speaker slot",
      "🏝️ Full 4-day access to the entire event — meals, panels, workshops, evenings on the property",
      "📸 Named the Title Partner of SSU Workshops 2026 — logo lockup on every piece of signage, materials, and attendee swag",
      "🎫 Dedicated exhibitor table in the highest-traffic area of the estate",
      // Email + community
      "📩 Featured spot in every pre-event and post-event email to the full SSU list (drip series + follow-ups)",
      "💬 Ongoing shoutouts in the SSU WhatsApp + Skool community leading up to and after the event",
      // Long-term
      "🔒 Category exclusivity — no competing brand in the room, on the footage, or in any post-event content",
      "🔁 First right of refusal for SSU Workshops 2027",
    ],
  },
  {
    slug: "supporting-partner",
    label: "Supporting Partner",
    price: "$1,400",
    spotsLabel: "2 spots",
    tagline: "Real brand presence + real conversations with 40+ swim school owners.",
    perks: [
      "Logo on event signage, program & shared attendee swag",
      "Exhibitor table with dedicated setup time",
      "Product mention on stage during Day 1 opening",
      "Included in pre-event announcement email to attendees",
      "Recognition in post-event thank-you email",
    ],
  },
  {
    slug: "community-sponsor",
    label: "Community Sponsor",
    price: "Product Sponsorship",
    spotsLabel: "Open spots",
    tagline: "Get your product in the hands of every attendee. Contact us for shipping information — this is no cost to the brand.",
    perks: [
      "Your product included in the attendee swag bag",
      "Brand mention in the swag-bag insert card",
      "Listed as a Community Sponsor on the event program",
      "Shout-out in our post-event thank-you email",
      "Ships to the venue — we handle the on-site distribution",
    ],
  },
];
